const {
  VCSTATE,
  BvFrontend,
  JSBundles,
  CSSBundles,
  TranslationsBundles,
} = window;

const casinoSectionComponents = {
  app: JSBundles.casinoSectionComponents,
  dependencies: [
    JSBundles.casinoGlobal,
    CSSBundles.casinoV2,
  ],
};

const genericQuestionnaire = {
  app: JSBundles.questionnaire,
  dependencies: [
    CSSBundles.questionnaire,
  ],
  getter: () => window.Questionnaire,
};

const sportSections = {
  app: JSBundles.sportSections,
  dependencies: [
    VCSTATE.SPORTSBOOK_BUNDLE_PATH,
    JSBundles.sportsbookCommon,
    JSBundles.sportsbookOverview,
    CSSBundles.inPlayOverview,
    CSSBundles.priceItUp,
  ],
};

const profitAndLoss = {
  app: JSBundles.profitAndLoss,
  dependencies: [
    CSSBundles.profitAndLoss,
  ],
  getter: () => ({ default: window.ProfitAndLoss }),
};

export default {
  homeComponents: {
    app: JSBundles.homeComponents,
    getter: () => window.HomeComponents,
  },
  banners: {
    app: BvFrontend.AssetsUrl.banners,
    getter: () => window.BVBanners,
  },
  featured: {
    app: VCSTATE.FEATURED_COMPONENT_BUNDLE_PATH,
    dependencies: [
      VCSTATE.SPORTSBOOK_BUNDLE_PATH,
      VCSTATE.SPORTSBOOK_COMPONENTS_COMMON_BUNDLE_PATH,
      CSSBundles.eventLevel, // TODO: convert event level to generic sportsbook styles
    ],
    getter: () => ({ default: window.featuredComponent }),
  },
  upcomingRaces: {
    app: VCSTATE.UPCOMING_RACES_COMPONENT_BUNDLE_PATH,
    dependencies: [
      VCSTATE.SPORTSBOOK_BUNDLE_PATH,
      VCSTATE.SPORTSBOOK_COMPONENTS_COMMON_BUNDLE_PATH,
      JSBundles.blazy,
    ],
    getter: () => ({ default: window.upcomingRacesComponent }),
  },
  trendingBets: {
    app: VCSTATE.TRENDING_BETS_COMPONENT_BUNDLE_PATH,
    dependencies: [
      VCSTATE.SPORTSBOOK_BUNDLE_PATH,
      VCSTATE.SPORTSBOOK_COMPONENTS_COMMON_BUNDLE_PATH,
    ],
    getter: () => ({ default: window.trendingBetsComponent }),
  },
  priceItUp: {
    app: VCSTATE.PRICE_IT_UP_COMPONENT_BUNDLE_PATH,
    dependencies: [
      CSSBundles.priceItUp,
      CSSBundles.betBuilder,
      VCSTATE.SPORTSBOOK_BUNDLE_PATH,
      VCSTATE.SPORTSBOOK_COMPONENTS_COMMON_BUNDLE_PATH,
    ],
    getter: () => ({ default: window.priceItUpComponent }),
  },
  inPlayWidget: {
    app: JSBundles.inPlayOverview,
    dependencies: [
      VCSTATE.SPORTSBOOK_BUNDLE_PATH,
      JSBundles.sportsbookCommon,
      CSSBundles.inPlayOverview,
    ],
    getter: () => ({ default: window.inPlayWidget }),
  },
  gamesList: {
    ...casinoSectionComponents,
    getter: () => ({ default: window.CasinoSectionComponents.GamesList }),
  },
  liveCasinoGamesList: {
    ...casinoSectionComponents,
    getter: () => ({ default: window.CasinoSectionComponents.LiveCasinoGamesList }),
  },
  widget: {
    ...casinoSectionComponents,
    getter: () => ({ default: window.CasinoSectionComponents.Widget }),
  },
  seo: {
    app: JSBundles.seo,
    getter: () => window.SeoComponent,
  },
  userInboxIcon: {
    app: JSBundles.userInboxIcon,
    getter: () => window.UserInboxIcon,
  },
  settings: {
    app: VCSTATE.SETTINGS_BUNDLE_PATH,
    dependencies: [
      BvFrontend.AssetsUrl.reduxForm,
      JSBundles.validations,
      CSSBundles.settings,
      CSSBundles.intTelInput,
    ],
    getter: () => ({ default: window.BvFrontend.Settings.app }),
  },
  userInbox: {
    app: JSBundles.userInboxModal,
    dependencies: [
      CSSBundles.userInbox,
    ],
    getter: () => window.UserInboxModal,
  },
  accountOverview: {
    app: JSBundles.accountOverview,
    dependencies: [
      CSSBundles.accountOverview,
      profitAndLoss.app,
      ...profitAndLoss.dependencies,
    ],
    softDependencies: [
      // Account overview uses portal translations
      // From now on this should change, even if some keys are duplicated in different scopes
      TranslationsBundles.saferGamblingPortal,
    ],
    getter: () => window.AccountOverview,
  },
  referAFriend: {
    app: JSBundles.refer_a_friend,
    dependencies: [
      CSSBundles.referAFriend,
    ],
    getter: () => ({ default: window.referAFriend }),
  },
  cashierActions: {
    app: JSBundles.cashierActions,
    dependencies: [
      CSSBundles.cashierActions,
      VCSTATE.REDUX_FORM_VENDOR_PATH,
      CSSBundles.liveChat,
    ],
    getter: () => ({ default: window.CashierActions }),
  },
  contactUs: {
    app: JSBundles.contactUs,
    dependencies: [
      BvFrontend.AssetsUrl.reduxForm,
      JSBundles.validations,
      CSSBundles.contactUs,
      CSSBundles.registration,
      CSSBundles.accountForms,
      CSSBundles.intTelInput,
    ],
    getter: () => ({ default: BvFrontend.ContactUs.app }),
  },
  accountHistory: {
    app: JSBundles.accountHistory,
    dependencies: [
      CSSBundles.offers,
    ],
    getter: () => window.AccountHistory,
  },
  passwordChange: {
    app: JSBundles.passwordChange,
    dependencies: [
      BvFrontend.AssetsUrl.reduxForm,
      JSBundles.validations,
      CSSBundles.accountForms,
    ],
    getter: () => ({ default: BvFrontend.PasswordChange.app }),
  },
  passwordReset: {
    app: JSBundles.passwordReset,
    dependencies: [
      BvFrontend.AssetsUrl.reduxForm,
      JSBundles.validations,
      CSSBundles.accountForms,
      CSSBundles.passwordReset,
      CSSBundles.liveChat,
    ],
    getter: () => ({ default: BvFrontend.PasswordReset.app }),
  },
  careers: {
    app: JSBundles.careers,
    getter: () => ({ default: window.CareersComponent }),
  },
  registration: {
    app: JSBundles.registration,
    dependencies: [
      BvFrontend.AssetsUrl.reduxForm,
      JSBundles.validations,
      CSSBundles.registration,
      CSSBundles.accountForms,
      CSSBundles.intTelInput,
      CSSBundles.liveChat,
    ],
    getter: () => window.Registration,
  },
  verificationZone: {
    app: JSBundles.verificationZone,
    dependencies: [
      JSBundles.sharedComponents,
      CSSBundles.verificationZone,
    ],
    softDependencies: [
      // TODO: Ideally the translations should be loaded only by the component using it
      // We are loading the whole verification zone when the page load
      // (after push message is received)
      // Even if the strategies are not used, to be improved
      TranslationsBundles.kycStrategies,
      TranslationsBundles.saferGamblingPortal,
    ],
    getter: () => ({ default: BvFrontend.VerificationZone.app }),
  },
  personalDetails: {
    app: JSBundles.personal_details,
    dependencies: [
      BvFrontend.AssetsUrl.reduxForm,
      JSBundles.validations,
      CSSBundles.personalDetails,
      CSSBundles.accountForms,
      CSSBundles.occupationAndSalary,
      CSSBundles.intTelInput,
    ],
    softDependencies: [
      TranslationsBundles.saferGamblingPortal,
      TranslationsBundles.occupationAndSalary,
    ],
    getter: () => ({ default: window.personalDetails }),
    features: {
      occupationAndSalary: {
        app: JSBundles.occupationAndSalary,
        dependencies: [
          JSBundles.sharedComponents,
          CSSBundles.occupationAndSalary,
        ],
        softDependencies: [
          TranslationsBundles.saferGamblingPortal,
        ],
        getter: () => window.OccupationAndSalary,
      },
    },
  },
  questionnaire: genericQuestionnaire,
  saferGamblingQuestionnaire: {
    app: JSBundles.saferGamblingQuestionnaire,
    softDependencies: [
      TranslationsBundles.saferGamblingQuestionnaire,
    ],
    getter: () => window.SaferGamblingQuestionnaire,
  },
  saferGamblingPortal: {
    app: JSBundles.saferGamblingPortal,
    dependencies: [
      JSBundles.sharedComponents,
      CSSBundles.saferGamblingPortal,
    ],
    softDependencies: [
      TranslationsBundles.saferGamblingPortal,
      TranslationsBundles.occupationAndSalary,
    ],
    getter: () => ({ default: BvFrontend.SaferGamblingPortal.app }),
    features: {
      contactUs: {
        app: JSBundles.contactUs,
        dependencies: [
          BvFrontend.AssetsUrl.reduxForm,
          JSBundles.validations,
          CSSBundles.contactUs,
        ],
        getter: () => ({ default: window.ContactUs }),
      },
      timeOut: {
        app: JSBundles.timeOut,
        dependencies: [
          BvFrontend.AssetsUrl.reduxForm,
          JSBundles.validations,
          CSSBundles.timeOut,
          CSSBundles.accountForms,
        ],
        softDependencies: [
          TranslationsBundles.timeOut,
        ],
        getter: () => ({ default: window.TimeOut }),
      },
      occupationAndSalary: {
        app: JSBundles.occupationAndSalary,
        dependencies: [
          BvFrontend.AssetsUrl.reduxForm,
          JSBundles.validations,
          CSSBundles.occupationAndSalary,
          CSSBundles.accountForms,
        ],
        getter: () => window.OccupationAndSalary,
      },
      profitAndLoss,
      selfExclusion: {
        app: JSBundles.selfExclude,
        dependencies: [
          BvFrontend.AssetsUrl.reduxForm,
          CSSBundles.selfExclude,
          CSSBundles.accountForms,
        ],
        softDependencies: [
          TranslationsBundles.selfExclusion,
        ],
        getter: () => ({ default: window.SelfExclude }),
      },
      sgQuestionnaire: {
        ...genericQuestionnaire,
        softDependencies: [
          TranslationsBundles.saferGamblingQuestionnaire,
        ],
      },
      allowanceQuestionnaire: {
        ...genericQuestionnaire,
        softDependencies: [
          TranslationsBundles.allowanceQuestionnaire,
        ],
      },
    },
  },
  twoFACode: {
    app: VCSTATE.TWOFACTOR_CODE_FEEDBACK_BUNDLE_PATH,
    dependencies: [
      CSSBundles.twofa,
    ],
    getter: () => ({ default: window.BvFrontend.twofa.CodeFeedback }),
  },
  twoFADeviceManager: {
    app: VCSTATE.TWOFACTOR_DEVICE_MANAGER_BUNDLE_PATH,
    dependencies: [
      CSSBundles.twofa,
    ],
    getter: () => ({ default: window.DeviceManager }),
  },
  twoFAEnable: {
    app: VCSTATE.TWOFACTOR_ENABLE_METHOD_BUNDLE_PATH,
    dependencies: [
      CSSBundles.twofa,
    ],
    getter: () => ({ default: window.BvFrontend.twofa.EnableMethod }),
  },
  twoFARegisterPhone: {
    app: VCSTATE.TWOFACTOR_REGISTER_PHONE_NUMBER_BUNDLE_PATH,
    dependencies: [
      JSBundles.intlTelInput,
      CSSBundles.twofa,
      CSSBundles.intTelInput,
    ],
    getter: () => ({ default: window.RegisterPhoneNumber }),
  },
  twoFATotpScan: {
    app: VCSTATE.TWOFACTOR_TOTP_SCAN_BUNDLE_PATH,
    dependencies: [
      CSSBundles.twofa,
    ],
    getter: () => ({ default: window.BvFrontend.twofa.TotpScan }),
  },
  twoFATotp: {
    app: VCSTATE.TWOFACTOR_TOTP_INTRO_BUNDLE_PATH,
    dependencies: [
      CSSBundles.twofa,
    ],
    getter: () => ({ default: window.BvFrontend.twofa.TotpIntro }),
  },
  twoFAVerifyPassword: {
    app: VCSTATE.TWOFACTOR_PASSWORD_BUNDLE_PATH,
    dependencies: [
      CSSBundles.twofa,
    ],
    getter: () => ({ default: window.TwoFAPassword }),
  },
  login: {
    app: JSBundles.loginModal,
    getter: () => window.LoginModal,
  },
  asiaCashier: {
    app: JSBundles.asiaCashier,
    dependencies: [
      CSSBundles.asiaCashier,
      CSSBundles.accountForms,
      CSSBundles.liveChat,
    ],
    getter: () => window.AsiaCashier,
  },
  emailVerification: {
    app: JSBundles.emailVerification,
    getter: () => window.EmailVerificationComponent,
  },
  casino: {
    app: JSBundles.casinov2,
    dependencies: [
      CSSBundles.casinoV2,
      BvFrontend.AssetsUrl.banners,
      JSBundles.casinoGlobal,
    ],
    getter: () => window.CasinoV2,
  },
  virtuals: {
    app: JSBundles.virtualSports,
    dependencies: [
      CSSBundles.virtualSports,
      VCSTATE.SPORTSBOOK_BUNDLE_PATH,
    ],
    getter: () => window.VirtualsComponent,
  },
  sportHome: {
    app: VCSTATE.SPORT_HOME_BUNDLE_PATH,
    dependencies: [
      VCSTATE.SPORTSBOOK_BUNDLE_PATH,
      CSSBundles.mediaStreaming,
    ],
    getter: () => window.SportHomeComponent,
  },
  competitions: {
    ...sportSections,
    getter: () => ({ default: window.SportSections.Competitions }),
  },
  selfExclude: {
    app: JSBundles.selfExclude,
    dependencies: [
      BvFrontend.AssetsUrl.reduxForm,
      CSSBundles.accountForms,
      CSSBundles.selfExclude,
    ],
    softDependencies: [
      TranslationsBundles.selfExclusion,
    ],
    getter: () => ({ default: window.SelfExclude }),
  },
  lottery: {
    app: JSBundles.lottoland,
    dependencies: [
      BvFrontend.AssetsUrl.banners,
    ],
    getter: () => window.CasinoLottoland,
  },
  betCalculator: {
    app: JSBundles.betCalculator,
    dependencies: [
      CSSBundles.betCalculator,
    ],
    getter: () => window.BetCalculator,
  },
  home: {
    app: JSBundles.home,
    dependencies: [
      BvFrontend.AssetsUrl.banners,
      JSBundles.homeComponents,
    ],
    getter: () => window.HomeComponent,
  },
  casinoGameLaunch: {
    app: JSBundles.casinoGameLaunch,
    getter: () => window.CasinoGameLaunch,
  },
  casinoOverlay: {
    app: JSBundles.casinoOverlay,
    getter: () => window.CasinoOverlay,
  },
  offers: {
    app: BvFrontend.AssetsUrl.offers,
    dependencies: [
      CSSBundles.offers,
    ],
    getter: () => ({ default: window.OffersComponent }),
  },
  quickDeposit: {
    app: JSBundles.quickDeposit,
    dependencies: [
      CSSBundles.quickDeposit,
      // TODO: Create a cashier/global JS and css bundles for pending withdrawals
      // And to be extended by shared things (cashier form, etc)
      CSSBundles.cashierActions,
    ],
    softDependencies: [
      TranslationsBundles.quickDeposit,
    ],
    getter: () => window.QuickDeposit,
  },
  staticPages: {
    app: JSBundles.staticPages,
    getter: () => window.StaticPagesComponent,
  },
  errorPage: {
    app: JSBundles.errorPage,
    getter: () => window.ErrorPageComponent,
  },
  mediaStreaming: {
    app: JSBundles.mediaStreaming,
    dependencies: [
      CSSBundles.mediaStreaming,
    ],
    getter: () => ({ default: window.MediaStreaming }),
  },
  feedback: {
    app: JSBundles.feedback,
    getter: () => window.Feedback,
  },
  betBuilder: {
    app: JSBundles.betBuilder,
    dependencies: [
      CSSBundles.betBuilder,
      VCSTATE.SPORTSBOOK_BUNDLE_PATH,
    ],
    getter: () => window.BetBuilder,
  },
  leaderboard: {
    app: JSBundles.leaderboard,
    dependencies: [
      VCSTATE.REACT_UTILS_VENDOR_PATH,
      CSSBundles.leaderboard,
      VCSTATE.SPORTSBOOK_BUNDLE_PATH,
      BvFrontend.AssetsUrl.banners,
    ],
    getter: () => ({ default: window.leaderBoard }),
  },
  greyHounds: {
    app: JSBundles.greyHounds,
    dependencies: [
      VCSTATE.SPORTSBOOK_BUNDLE_PATH,
    ],
    getter: () => window.GreyHounds,
  },
  greyHoundsTimeTable: {
    app: JSBundles.greyHoundsTimeTable,
    getter: () => window.GreyHoundsTimeTable,
  },
  sportSectionsCustomList: {
    ...sportSections,
    getter: () => ({ default: window.SportSections.CustomList }),
  },
  customerConsentModal: {
    app: JSBundles.customerConsentModal,
    dependencies: [],
    getter: () => ({ default: window.CustomerConsentModal }),
  },
  fundsProtectionModal: {
    app: JSBundles.fundsProtectionModal,
    dependencies: [],
    getter: () => ({ default: window.FundsProtectionModal }),
  },
  inPlayOverview: {
    app: JSBundles.inPlayOverview,
    dependencies: [
      VCSTATE.SPORTSBOOK_BUNDLE_PATH,
      JSBundles.sportsbookCommon,
      CSSBundles.inPlayOverview,
    ],
    getter: () => ({ default: window.inPlayOverviewComponent }),
  },
  betFinder: {
    app: JSBundles.betFinder,
    dependencies: [
      VCSTATE.SPORTSBOOK_BUNDLE_PATH,
      CSSBundles.betFinder,
    ],
    getter: () => window.BetFinderComponent,
  },
  eventExtraInformation: {
    app: VCSTATE.SPORTSBOOK_BUNDLE_PATH,
    dependencies: [
      CSSBundles.priceItUp,
    ],
    getter: () => window.SportsbookEventExtraInformation,
  },
  eventComponents: {
    app: VCSTATE.EVENT_COMPONENTS_BUNDLE_PATH,
    dependencies: [
      VCSTATE.SPORTSBOOK_BUNDLE_PATH,
      CSSBundles.eventComponents,
    ],
    getter: () => window.SportsbookEventComponents,
  },
  eventLevel: {
    app: JSBundles.eventLevel,
    dependencies: [
      CSSBundles.priceItUp,
      VCSTATE.SPORTSBOOK_BUNDLE_PATH,
      VCSTATE.SCOREBOARDS_BUNDLE_PATH,
      VCSTATE.BODYMOVIN_PATH,
      CSSBundles.eventLevel,
    ],
    getter: () => window.EventLevel,
  },
  scoreboard: {
    app: VCSTATE.SCOREBOARDS_BUNDLE_PATH,
    getter: () => ({ default: window.Scoreboard }),
  },
  horseRacing: {
    app: JSBundles.horseRacingRacecard,
    dependencies: [
      VCSTATE.SPORTSBOOK_BUNDLE_PATH,
      VCSTATE.EVENT_COMPONENTS_BUNDLE_PATH,
      CSSBundles.priceItUp,
      CSSBundles.racecard,
      CSSBundles.eventComponents,
    ],
    getter: () => ({ default: window.HorseRacing }),
  },
  profitAndLoss,
  timeOutBanner: {
    app: JSBundles.timeOutBanner,
    dependencies: [
      CSSBundles.timeOutBanner,
    ],
    getter: () => window.TimeOutBanner,
  },
  saferGamblingLanding: {
    app: JSBundles.saferGamblingLanding,
    dependencies: [
      CSSBundles.saferGamblingLanding,
    ],
    softDependencies: [
      TranslationsBundles.saferGamblingQuestionnaire,
    ],
    getter: () => window.SaferGamblingLanding,
  },
};
